import ServiceDetailPage from "./ServiceDetailPage";
import serviceContent from "./serviceContent";

const Animation = () => <ServiceDetailPage service={serviceContent.animation} />;

export default Animation;
